import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mainTable" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", {
    class: "largeTitle",
    colspan: "7"
  }, "Qualifikation Block I")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Fach"),
  /*#__PURE__*/_createElementVNode("th", null, "11 / 2"),
  /*#__PURE__*/_createElementVNode("th", null, "12 / 1"),
  /*#__PURE__*/_createElementVNode("th", null, "12 / 2"),
  /*#__PURE__*/_createElementVNode("th", null, "13 / 1"),
  /*#__PURE__*/_createElementVNode("th", null, "Anzahl eingebr. Kurse"),
  /*#__PURE__*/_createElementVNode("th", null, "Eingebr. Punktzahl")
], -1)
const _hoisted_4 = ["onInput"]
const _hoisted_5 = { class: "leftBorder" }
const _hoisted_6 = ["name"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, "Facharbeit:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_10 = { class: "leftBorder resultField" }
const _hoisted_11 = { class: "resultField" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MarkInputComponent = _resolveComponent("MarkInputComponent")!
  const _component_QualifikationGesamtComponent = _resolveComponent("QualifikationGesamtComponent")!
  const _component_Qualifikation2Component = _resolveComponent("Qualifikation2Component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ownSubjects, (subject, index) => {
        return (_openBlock(), _createElementBlock("tr", { key: index }, [
          _createElementVNode("td", null, [
            _createTextVNode(_toDisplayString(index < 3 ? "LK" : "GK") + " " + _toDisplayString(subject) + " ", 1),
            (index > 2)
              ? (_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "checkbox",
                  name: "muendlich",
                  title: "Mündliches ABI?",
                  onInput: (e) => _ctx.muendlichChange(e, subject)
                }, null, 40, _hoisted_4))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_MarkInputComponent, {
              courseUsed: _ctx.usedCourses[index][0] != 0,
              modelValue: _ctx.marks[subject]['11_2'],
              "onUpdate:modelValue": ($event: any) => ((_ctx.marks[subject]['11_2']) = $event)
            }, null, 8, ["courseUsed", "modelValue", "onUpdate:modelValue"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_MarkInputComponent, {
              courseUsed: _ctx.usedCourses[index][1] != 0,
              modelValue: _ctx.marks[subject]['12_1'],
              "onUpdate:modelValue": ($event: any) => ((_ctx.marks[subject]['12_1']) = $event)
            }, null, 8, ["courseUsed", "modelValue", "onUpdate:modelValue"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_MarkInputComponent, {
              courseUsed: _ctx.usedCourses[index][2] != 0,
              modelValue: _ctx.marks[subject]['12_2'],
              "onUpdate:modelValue": ($event: any) => ((_ctx.marks[subject]['12_2']) = $event)
            }, null, 8, ["courseUsed", "modelValue", "onUpdate:modelValue"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_MarkInputComponent, {
              courseUsed: _ctx.usedCourses[index][3] != 0,
              modelValue: _ctx.marks[subject]['13_1'],
              "onUpdate:modelValue": ($event: any) => ((_ctx.marks[subject]['13_1']) = $event)
            }, null, 8, ["courseUsed", "modelValue", "onUpdate:modelValue"])
          ]),
          _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.getUsedCourseNum(index)), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.getSubjectPoints(index, subject)), 1)
        ]))
      }), 128)),
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, [
          _withDirectives(_createElementVNode("select", {
            name: "subject",
            id: "subject",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newSubject) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subjects, (subject, index) => {
              return (_openBlock(), _createElementBlock("option", {
                key: index,
                name: subject
              }, _toDisplayString(subject), 9, _hoisted_6))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.newSubject]
          ]),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ownSubjects.push(_ctx.newSubject)))
          }, "Fach hinzufügen")
        ]),
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("td", null, [
          _createVNode(_component_MarkInputComponent, {
            courseUsed: _ctx.facharbeit > 4,
            modelValue: _ctx.facharbeit,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.facharbeit) = $event))
          }, null, 8, ["courseUsed", "modelValue"])
        ]),
        _hoisted_9,
        _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.getTotalUsedCourseNum()), 1),
        _createElementVNode("td", _hoisted_11, _toDisplayString(Math.round((_ctx.getTotalPointSum() / 44) * 40)), 1)
      ]),
      _createVNode(_component_Qualifikation2Component, {
        subjectsMuendlich: _ctx.subjectsMuendlich,
        ownSubjects: _ctx.ownSubjects,
        onPointsChange: _cache[4] || (_cache[4] = (res) => (this.pointsQuali2 = res))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_QualifikationGesamtComponent, {
            gesamtpunktzahl: _ctx.pointsQuali1 + _ctx.pointsQuali2,
            marks: _ctx.marks,
            ownSubjects: _ctx.ownSubjects,
            onImported: _cache[3] || (_cache[3] = 
          (v) => {
            _ctx.ownSubjects = v.ownSubjects;
            _ctx.marks = v.marks;
          }
        )
          }, null, 8, ["gesamtpunktzahl", "marks", "ownSubjects"])
        ]),
        _: 1
      }, 8, ["subjectsMuendlich", "ownSubjects"])
    ]),
    _createElementVNode("p", null, _toDisplayString(_ctx.usedCourses), 1)
  ], 64))
}